// UI constants matching mobile app's design system
export const UI = {
  colors: {
    primary: '#018B9C',
    background: '#E6F4F6',
    card: 'rgba(255,255,255,0.82)',
    text: '#1F2937',
    textStrong: '#111827',
    primaryFont: '#111827',
    secondaryFont: '#6B7280',
    muted: '#6B7280',
    kicker: '#7C8B8A',
    inputBg: 'rgba(249,250,251,0.9)',
    border: 'rgba(17,24,39,0.06)',
    borderStrong: 'rgba(17,24,39,0.08)',
    placeholder: '#9CA3AF',
  },
} as const;

// Format phone number for display
export function formatPhoneNumber(phone: string | null): string {
  if (!phone) return 'Not set';
  // Remove all non-digits
  const cleaned = phone.replace(/\D/g, '');
  // Format as (XXX) XXX-XXXX if it's a 10-digit US number
  if (cleaned.length === 10) {
    return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(6)}`;
  }
  // Handle +1 prefix
  if (cleaned.length === 11 && cleaned.startsWith('1')) {
    return `+1 (${cleaned.slice(1, 4)}) ${cleaned.slice(4, 7)}-${cleaned.slice(7)}`;
  }
  return phone;
}

// Format date for "Member since" display
export function formatMemberSince(dateStr: string): string {
  return new Date(dateStr).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
  });
}

// Format date for invite display
export function formatInviteDate(dateStr: string): string {
  return new Date(dateStr).toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  });
}
